'use strict';

(function () {
  if (!customElements.get('testimonials-section')) {
    class TestimonialsSection extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
        this.nextBtn = this.querySelector('.swiper-button-next');
        this.prevBtn = this.querySelector('.swiper-button-prev');
      }

      connectedCallback() {
        this.initSwiper();
        this.setupExternalNavigation();
        this.updateNavigationButtons();
      }

      setupExternalNavigation = () => {
        this.nextBtn.addEventListener('click', () => {
          this.swiper.slideNext();
					this.updateNavigationButtons();
        });
        this.prevBtn.addEventListener('click', () => {
          this.swiper.slidePrev();
					this.updateNavigationButtons();
        });
      };

      updateNavigationButtons = () => {
        if (!this.swiper) return;
				if (this.swiper.isBeginning && !this.swiper.isEnd) {
					this.nextBtn.classList.remove('disabled');
					this.prevBtn.classList.add('disabled');
				} else if (this.swiper.isEnd && !this.swiper.isBeginning) {
					this.prevBtn.classList.remove('disabled');
					this.nextBtn.classList.add('disabled');
				} else if (this.swiper.isEnd && this.swiper.isBeginning) {
					this.prevBtn.classList.add('disabled');
					this.nextBtn.classList.add('disabled');
				} else {
					this.prevBtn.classList.remove('disabled');
					this.nextBtn.classList.remove('disabled');
				}
      };

      initSwiper = () => {
        this.slider = this.querySelector('.swiper');
				if(!this.slider) return;

				let { autoplay, speed, changeSpeed, spaceBetween = 16, spaceBetweenPc = 16} = this.dataset;

				const swiperParams = {
					speed,
					slidesPerView: 'auto',
					scrollbar: true,
					spaceBetween,
					scrollbar: {
						el: '.swiper-scrollbar',
					},
					breakpoints: {
						750: {
							spaceBetween: spaceBetweenPc,
						},
					},
				}

				if (autoplay == 'true') {
					swiperParams.autoplay = {
						delay: changeSpeed
					};
				}

        this.swiper = new Swiper(this.slider, {
          ...swiperParams,
          on: {
            slideChange: this.updateNavigationButtons,
            init: this.updateNavigationButtons,
						autoplay: () => {
              this.updateNavigationButtons();
            }
          },
        });
      };
    }

    TestimonialsSection.prototype.swiperParams = {
    };

    customElements.define('testimonials-section', TestimonialsSection);
  }
})();
